import { render, staticRenderFns } from "./DefaultAppPicker.vue?vue&type=template&id=5d82d7da&scoped=true&"
import script from "./DefaultAppPicker.vue?vue&type=script&lang=js&"
export * from "./DefaultAppPicker.vue?vue&type=script&lang=js&"
import style0 from "./DefaultAppPicker.vue?vue&type=style&index=0&id=5d82d7da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d82d7da",
  null
  
)

export default component.exports